module.exports = __webpack_public_path__ + "static/media/Logo-Trazability.c4719e70.png";